var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 3.42041C12.0847 3.42041 12.1682 3.44225 12.2421 3.48389C12.316 3.5256 12.3779 3.58603 12.4218 3.65869L12.4227 3.66064L16.1327 9.73975V9.74072L16.1356 9.74365C16.3372 10.0681 16.1007 10.5005 15.7098 10.5005H8.28015C7.88933 10.5005 7.65282 10.0681 7.85437 9.74365L7.85632 9.74072L11.576 3.66064L11.578 3.65869C11.6219 3.58603 11.6838 3.5256 11.7577 3.48389C11.8316 3.44221 11.915 3.42043 11.9999 3.42041Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.5C19.7091 13.5 21.5 15.2909 21.5 17.5C21.5 19.7091 19.7091 21.5 17.5 21.5C15.2909 21.5 13.5 19.7091 13.5 17.5C13.5 15.2909 15.2909 13.5 17.5 13.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H10C10.2739 14 10.5 14.2261 10.5 14.5V20.5C10.5 20.7739 10.2739 21 10 21H4C3.72614 21 3.5 20.7739 3.5 20.5V14.5C3.5 14.2261 3.72614 14 4 14Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.0e0259482406deeadd367fe92375e4b7.svg";
export { ForwardRef as ReactComponent };